import { useState } from 'react'
import '../Styles/formRegister.css'
import { db } from '../firebaseConfig'
import { collection, addDoc } from 'firebase/firestore'
import Exit from '../Components/Exit'
import { useNavigate } from 'react-router-dom'


const FormRegister = () => {

    const navigate = useNavigate()
    const [dataClient, setDataClient] = useState({
        name: '',
        data_birth: '',
        phone: '',
        email: '',
        profession: ''
    })

    const handleChange = (e) => {
        const { name, value } = e.target
        setDataClient((prevData) => ({
            ...prevData,
            [name]: value
        }))
    }

    const validateForm = () => {
        const { name, data_birth, phone, email, profession } = dataClient

        if (!name || !data_birth || !phone || !email || !profession) {
            alert('Por favor, preencha todos os campos.')
            return false
        }

        const birthDate = new Date(data_birth)
        const today = new Date()
        if (birthDate >= today) {
            alert('Data de nascimento inválida.')
            return false
        }

        const phonePattern = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/
        if (!phonePattern.test(phone)) {
            alert('Telefone inválido')
            return false
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailPattern.test(email)) {
            alert('Por favor, insira um e-mail válido.')
            return false
        }

        return true
    }

    const registerClient = async (e) => {
        e.preventDefault()

        if (!validateForm()) {
            return
        }

        try {
            await addDoc(collection(db, "client"), { dataClient: dataClient })
            alert('Cliente cadastrado com sucesso.')
            setDataClient({
                name: '',
                data_birth: '',
                phone: '',
                email: '',
                profession: ''
            });
        } catch (e) {
            alert('Ocorreu um erro: ', e)
        }
    }   

    return (
        <section className='full-window flex-center flex-column background-dark'>
            <div id='exit-form'>
                <Exit/>
            </div>
            <div className='flex-center flex-column flex__gap-50'>
                <div className='text-center'>
                    <h1 className='title-main'>Cadastrar <span>Cliente</span></h1>
                    <p className='paragraph-default'>Realize o cadastro do cliente para registrá-lo em nosso banco de dados</p>
                </div>
                
                <form action="*" id='form-register' className='flex-center flex-column'>
                    <fieldset className='flex-center flex__gap-20 fieldset-register'>
                        <div>
                            <label htmlFor="name">Nome Completo:</label>
                            <input 
                            onChange={handleChange}
                            type="text" 
                            id="name" 
                            className='input-register'
                            name="name" 
                            value={dataClient.name}
                            required/>
                        </div>

                        <div>
                            <label htmlFor="data_birth">Data de Nascimento:</label>
                            <input 
                            onChange={handleChange}
                            type="date" 
                            id="data_birth" 
                            className='input-register' 
                            name="data_birth" 
                            value={dataClient.data_birth}
                            required/>
                        </div>
                    </fieldset>

                    <fieldset className='flex-center flex__gap-20 fieldset-register'>
                        <div>
                            <label htmlFor="phone">Telefone:</label>
                            <input 
                            onChange={handleChange}
                            type="tel" 
                            id="phone" 
                            className='input-register' 
                            name="phone" 
                            value={dataClient.phone}
                            required/>
                        </div>

                        <div>
                            <label htmlFor="email">Email:</label>
                            <input 
                            onChange={handleChange}
                            type="email" 
                            id="email" 
                            className='input-register' 
                            name="email" 
                            value={dataClient.email}
                            required/>
                        </div>
                    </fieldset>

                    <label htmlFor="profession">Profissão:</label>
                    <input 
                    onChange={handleChange}
                    type="text" 
                    id="profissao" 
                    className='input-register' 
                    name="profession" 
                    value={dataClient.profession}
                    required/>

                    <input 
                    onClick={registerClient}
                    type="button" 
                    value="Cadastrar" 
                    className="login-btn cursor-pointer inputs-forms"/>
                </form>
            </div>
            <p className='fixed-bottom cursor-pointer' onClick={() => navigate('/apresentacao')}>Ir para Apresentação</p>
        </section>

    )
}

export default FormRegister
